import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  access_token: null,
  refresh_token: null,
  roles: null,
  profile: {},
}

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setProfile(state, action) {
      const incomingProfile = action.payload.profile
      // Refetch account-information bisa jalan sebelum pembayaran lunas di backend, dan saat
      // itu user_type masih UNDECIDED. State ini di-persist & semua guard layout menendang
      // UNDECIDED ke /onboarding, jadi jangan pernah turunkan FREE/PAID ke UNDECIDED.
      const shouldKeepUserType =
        incomingProfile?.user_type === 'UNDECIDED' &&
        ['FREE', 'PAID'].includes(state.profile?.user_type)
      state.profile = shouldKeepUserType
        ? { ...incomingProfile, user_type: state.profile.user_type }
        : incomingProfile
    },
    setRoles(state, action) {
      state.roles = action.payload.roles
    },
    login(state, action) {
      state.access_token = action.payload.access_token
      state.refresh_token = action.payload.refresh_token
    },
    setEmailAddress(state, action) {
      state.profile.email = action.payload.email
      state.profile.updated_at = action.payload.updated_at
    },
    logout(state) {
      Object.assign(state, initialState)
      window.location.href = '/login'
    }
  }
})

export const authActions = authSlice.actions

export const authReducer = authSlice.reducer
